import { createAction } from '@ngrx/store';
import { AuthTypes } from './auth.type';
import { AuthModel } from './auth.model';

export const login = createAction(
  AuthTypes.POST_AUTH_LOGIN,
  (payload: any) => ({
    payload,
  })
);
export const loginSuccess = createAction(
  AuthTypes.POST_AUTH_LOGIN_SUCCESS,
  (payload: any) => ({
    payload,
  })
);
export const loginCancel = createAction(AuthTypes.POST_AUTH_LOGIN_CANCEL);

export const logout = createAction(AuthTypes.POST_AUTH_LOGOUT);
export const logoutSuccess = createAction(AuthTypes.POST_AUTH_LOGOUT_SUCCESS);

export const getCompanyDetails = createAction(
  AuthTypes.GET_COMPANY_DETAILS,
  (payload: any) => ({
    payload,
  })
);
export const getCompanyDetailsSuccess = createAction(
  AuthTypes.GET_COMPANY_DETAILS_SUCCESS,
  (payload: any) => ({
    payload,
  })
);

export const getCompanyKioskSettings = createAction(
  AuthTypes.GET_COMPANY_KIOSK_SETTINGS,
  (payload: string) => ({
    payload,
  })
);

export const getCompanyKioskSettingsSuccess = createAction(
  AuthTypes.GET_COMPANY_KIOSK_SETTINGS_SUCCESS,
  (payload: any) => ({
    payload,
  })
);
